import React from 'react';
import ReactDOM from 'react-dom';

import * as clientRequest from '../helpers/client-request';
import { sendHeightToParent, notifyParent } from './../helpers/collapse-iframe-message';
import * as ec from '../tracking/event-collector';
import { addClickEventsEventCollector, addClickEventsPrometheus, addInscreenEventsPrometheus } from './blink';
import ResultItem from '../../../common/ResultItem';
import srcsetController from '../controllers/srcset-controller';

import RealestateResults, { Props } from '../../components/banner/realestate/realestate-results';
import CarResults from '../../components/banner/motor/car-results';
import { RecommendationData, Item } from '../../../types/recommendation';
import { TrackingData } from '../../components/types';

const itemsMapper = (ad: Partial<Item>) => {
    let mainImage = ad.imageUrl;
    let landscape = true;
    if (!mainImage) {
        const image = ad.image;
        if (image) {
            mainImage = image.url;
            if (image.width && image.height) {
                if (image.width < image.height) {
                    landscape = false;
                }
            }
        }
    }

    const values = {
        heading: ad.heading,
        price: ad.label,
        adId: ad.itemId,
        landscape,
        mainImage: `https://images.finncdn.no/dynamic/640w/${mainImage}`,
    };
    return new ResultItem(values).toJSON();
};

function mapAds (data: RecommendationData) {
    if (data.items) {
        return data.items.map(itemsMapper);
    } else {
        return [];
    }
}

function _getContent (url: string, options: TrackingData & { name?: string }, container: HTMLElement, cb: (err: Error) => void) {
    let Component: any;
    switch (options.name) {
        case 'CAR':
            Component = CarResults;
            break;
        case 'REALESTATE':
            Component = RealestateResults;
            break;
        default:
            Component = RealestateResults;
            break;
    }

    clientRequest.getMatchAd(url, (err, data) => {
        if (err) {
            cb(err);
            return;
        }

        if (options) {
            data._internal = options;
        }

        if (data.size === 0) {
            ec.trackRecommendationNotFound(data, options);
            setTimeout(() => {
                cb(new Error('No match found'));
            }, 300);
        } else {
            ec.trackShow(data, options);

            const adverts = mapAds(data);
            if (adverts.length > 0) {
                const resultItem = adverts[0];
                ReactDOM.render(
                    <Component resultItem={resultItem} version={data.version} uuid={data.uuid} renderType="client" />,
                    container,
                    cb
                );
            } else {
                cb(new Error('Results are empty'));
            }
        }
    });
}

export function getContent (url: string, container: HTMLElement, options: TrackingData, cb: (error: Error | null, data?: {}) => void) {
    _getContent(url, options, container, (err: Error) => {
        if (err) {
            cb(err);
            notifyParent(false);
        } else {
            srcsetController.callable(container);
            addClickEventsEventCollector(container, options);
            addClickEventsPrometheus(container);
            addInscreenEventsPrometheus(container);
            notifyParent(true);
            sendHeightToParent();

            if (cb) {
                cb(null);
            }
        }
    });
}
